import { render } from "./WorkplaceMatch.vue?vue&type=template&id=c8d73d4c&scoped=true"
import script from "./WorkplaceMatch.vue?vue&type=script&lang=js"
export * from "./WorkplaceMatch.vue?vue&type=script&lang=js"

import "./WorkplaceMatch.vue?vue&type=style&index=0&id=c8d73d4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c8d73d4c"]])

export default __exports__